import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UiToastComponent } from '@marianaLinoGit/model-ui-kit';
import { ToastService } from '@services/toast.service';

@Component({
	standalone: true,
	selector: 'app-toast-host',
	templateUrl: './toast-host.html',
	imports: [TranslateModule, UiToastComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastHostComponent {
	readonly toastService = inject(ToastService);
}
